import React from 'react';
import { Outlet } from 'react-router';
import { useSelector } from 'react-redux';

import { GUEST_PATH } from '../../../../constants';

const SellingGroups = React.lazy(() => import('.'));
const SellingGroupDetails = React.lazy(() => import('./SellingGroup/SellingDetails'));

const GetSellingGroupName = ({ match }) => {
     const sellingGroups = useSelector((state) => state.subscriber.sellingGroups);

     const { slug } = match.params;
     const sellingGroup = sellingGroups.find((item) => item.slug === slug);

     return <span>{sellingGroup?.headlineDetail || sellingGroup?.headline || '...'}</span>;
};

const Routes = {
     path: GUEST_PATH.SELLING_GROUPS,
     breadcrumb: 'Training Products',
     element: <Outlet />,
     children: [
          { index: true, element: <SellingGroups /> },
          {
               path: GUEST_PATH.SELLING_GROUPS_DETAIL,
               breadcrumb: GetSellingGroupName,
               element: <SellingGroupDetails />,
          },
     ],
};

export default Routes;
